//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"Acceleration",0,"Expression",0],[0,"AnalysisRemoteForceType",1,0],[1,"BearingAngular",0,"Expression",0],[0,"ComponentCSYS",1,"CoordinateSystem",0],[0,"FaceVector",1,"Direction",0],[1,"Force",0,"Expression",0],[0,"ForceDistributionMethod",1,0],[0,"ForceLocation",1,"Point",0],[0,"ForceObjectOption",1,0],[0,"ForceType",1,0],[1,"ForceX",0,"Expression",0],[1,"ForceY",0,"Expression",0],[1,"ForceZ",0,"Expression",0],[1,"HeatFlux",0,"Expression",0],[1,"MaxDisplacement",0,"Expression",0],[1,"Moment",0,"Expression",0],[1,"MomentX",0,"Expression",0],[1,"MomentY",0,"Expression",0],[1,"MomentZ",0,"Expression",0],[0,"Name",1,0],[1,"Pressure",0,"Expression",0],[0,"RemoteForceOption",1,0],[0,"RemoteForcePoint",1,"Point",0],[0,"RemoteMomentVector",1,"Direction",0],[0,"ReverseBearingLoadDirection",1,0],[0,"ReversePressureDirection",1,0],[1,"SelectFace",0,"ScCollector",0],[1,"Torque",0,"Expression",0],[0,"TorqueAxis",1,"Axis",0],[0,"Type",1,0],[0,"UserSetName",1,0]],[[[],"UpdateDisplay",{},0,0]],[]];
SPLM.DesignSimulation.AnalysisLoadBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.AnalysisLoadBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.AnalysisLoadBuilder.AnalysisLoadType = Object.freeze({
    "Force" : "Force", "BearingLoad" : "BearingLoad", "Pressure" : "Pressure", "Torque" : "Torque", "Acceleration" : "Acceleration", "EnforcedDisplacement" : "EnforcedDisplacement", "RemoteForce" : "RemoteForce", "HeatFlux" : "HeatFlux"});

SPLM.DesignSimulation.AnalysisLoadBuilder.AnalysisLoadForceType = Object.freeze({
    "ByVector" : "ByVector", "ByComponent" : "ByComponent"});

SPLM.DesignSimulation.AnalysisLoadBuilder.ForceObjectType = Object.freeze({
    "Face" : "Face", "Point" : "Point"});

SPLM.DesignSimulation.AnalysisLoadBuilder.ForceDistributionType = Object.freeze({
    "EvenOverFaceArea" : "EvenOverFaceArea", "EvenOverFaceNumber" : "EvenOverFaceNumber", "ConstantPerFace" : "ConstantPerFace"});

SPLM.DesignSimulation.AnalysisLoadBuilder.RemoteForceType = Object.freeze({
    "Force" : "Force", "Moment" : "Moment", "ForceAndMoment" : "ForceAndMoment"});

export default SPLM;